import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '@material-ui/core';

import Styled from './SessionExpiredError.styles';

import ReturnToSpringHealthButton from '@/components/ReturnToSpringHealthButton/ReturnToSpringHealthButton';
import GabrielTired from '@/assets/GabrielTired.svg';
import DaylightExpiredIllustration from '@/assets/spec_no_redlines.svg';

const PRODUCT_ILLUSTRATIONS: Record<string, string> = {
  daylight: DaylightExpiredIllustration,
  // TODO: Add sleepio-specific illustration when asset is available
};

interface SessionExpiredErrorProps {
  product: string;
}

const SessionExpiredError: React.FC<SessionExpiredErrorProps> = ({ product }) => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="xs">
      {PRODUCT_ILLUSTRATIONS[product] ? (
        <Styled.CircularIllustrationWrapper>
          <Styled.CircularIllustration alt="Session expired" src={PRODUCT_ILLUSTRATIONS[product]} />
        </Styled.CircularIllustrationWrapper>
      ) : (
        <Styled.Illustration alt="Session expired" src={GabrielTired} />
      )}
      <Styled.ContentWrapper>
        <Styled.Title>{t('coverage.spring_health.session_expired.title')}</Styled.Title>
        <Styled.Subtitle>{t('coverage.spring_health.session_expired.subtitle')}</Styled.Subtitle>
        <ReturnToSpringHealthButton product={product} fullWidth />
      </Styled.ContentWrapper>
    </Container>
  );
};

export default SessionExpiredError;
